import script from "./AdvisorListView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvisorListView.vue?vue&type=script&setup=true&lang=js"

import "./AdvisorListView.vue?vue&type=style&index=0&id=1db06d75&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db06d75"]])

export default __exports__